import { uuidv7 } from "uuidv7";
import { getFingerprint } from "@thumbmarkjs/thumbmarkjs";
import {
  ClickIssueDataDto,
  ScanRepositoryDataDto,
  ViewAnalysisDataDto,
  ViewPageDataDto,
} from "@/api/generated/models";
import { InteractionTypeDto } from "@/api/generated/models/interactionTypeDto";
import { setPreviousId, getPreviousId } from "@/utilities/previousIdUtil";
import {
  addUserInteractionClickIssue,
  addUserInteractionScanRepository,
  addUserInteractionViewAnalysis,
  addUserInteractionViewPage,
} from "@/api/generated/endpoints/interaction-controller/interaction-controller";

type ScanRepositoryInput = {
  type: typeof InteractionTypeDto.ScanRepository;
} & ScanRepositoryDataDto;

type ViewAnalysisInput = {
  type: typeof InteractionTypeDto.ViewAnalysis;
} & ViewAnalysisDataDto;

type ViewPageInput = {
  type: typeof InteractionTypeDto.ViewPage;
} & ViewPageDataDto;

type ClickIssueInput = {
  type: typeof InteractionTypeDto.ClickIssue;
} & ClickIssueDataDto;


export const trackUserInteraction = async (
  interactionData: ScanRepositoryInput | ViewAnalysisInput | ViewPageInput | ClickIssueInput,
): Promise<void> => {
  const fingerprint = await getFingerprint();
  const id = uuidv7();
  const previousId = getPreviousId();

  switch (interactionData.type) {
    case InteractionTypeDto.ScanRepository:
      await addUserInteractionScanRepository({
        data: {
          repositoryUrl: interactionData.repositoryUrl,
          type: InteractionTypeDto.ScanRepository,
        },
        id,
        previousId,
        fingerprint,
      });
      break;
    case InteractionTypeDto.ViewAnalysis:
      await addUserInteractionViewAnalysis({
        data: {
          repositoryName: interactionData.repositoryName,
          type: InteractionTypeDto.ViewAnalysis,
        },
        id,
        previousId,
        fingerprint,
      });
      break;
    case InteractionTypeDto.ViewPage:
      await addUserInteractionViewPage({
        data: { 
          pageUrl: interactionData.pageUrl,
          type: InteractionTypeDto.ViewPage,
        },
        id,
        previousId,
        fingerprint,
      });
      break;
    case InteractionTypeDto.ClickIssue:
      await addUserInteractionClickIssue({
        data: {
          issueUrl: interactionData.issueUrl,
          repositoryUrl: interactionData.repositoryUrl,
          issueStatus: interactionData.issueStatus,
          type: InteractionTypeDto.ClickIssue,
        },
        id,
        previousId,
        fingerprint,
      });
      break;
    default:
      throw new Error("Invalid interaction type");
  }

  setPreviousId(id);
};
